<template>
<div>
    <div class="row" v-if="loading">
        <div class="col-xs-12">
            <div class="panel panel-default">
                <div class="panel-body">
                    <p class="h3 text-center">Loading...</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row" v-if="errors.length > 0">
        <div v-for="error in errors" v-bind:key="error.code">
            {{ error.message }}
        </div>

    </div>
    <div class="row" v-if="success">

    </div>

    <div class="row" v-if="displayBankTransfer">
        <div class="col-sm-12 col-xs-12">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3 class="panel-title"><input type="radio" v-model="selected_payment_method" value="bank_transfer" />&nbsp;Bank Transfer</h3>
                </div>
                <div class="panel-body" id="bank_transfer_options" v-show="selected_payment_method=='bank_transfer'">
                    <p>If you are paying with a bank transfer, enter the details below and we will confirm once payment is received.</p>
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label class="control-label">Payment Date</label>
                            <datepicker2 v-model="payment_details.payment_date" valueFormat="yyyy-mm-dd" displayFormat="dd/mm/yyyy" placeholder="Payment Date"/>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label class="control-label">Amount</label>
                            <div class="input-group">
                                <span class="input-group-addon">£</span>
                                <input type="text" class="form-control" v-model="payment_details.payment_amount" />
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12">
                        <div class="form-group">
                            <label class="control-label">Payment Reference</label>
                            <input type="text" class="form-control" v-model="payment_details.payment_reference" />
                        </div>
                    </div>


                </div>
                <div class="panel-footer" v-show="selected_payment_method=='bank_transfer'">
                    <div class="col-xs-12 text-right">
                        <button class="btn btn-primary" v-on:click="makeOfflinePayment()">Record Payment Details</button>
                    </div>
                    <div class="clearfix"></div>

                </div>

            </div>
        </div>
    </div>


    <div class="row" v-if="displayCashCheque">
        <div class="col-sm-12 col-xs-12">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3 class="panel-title"><input type="radio" v-model="selected_payment_method" value="cheque" />&nbsp;Cheque / Cash</h3>
                </div>
                <div class="panel-body" id="cheque_options" v-show="selected_payment_method=='cheque'">
                    <p>If you are paying with a cheque or cash, enter the details below and we will confirm once payment is received. Please include details of who you gave the cheque or cash to.</p>
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label class="control-label">Payment Date</label>
                            <datepicker2 v-model="payment_details.payment_date" valueFormat="yyyy-mm-dd" displayFormat="dd/mm/yyyy" placeholder="Payment Date"/>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label class="control-label">Amount</label>
                            <div class="input-group">
                                <span class="input-group-addon">£</span>
                                <input type="text" class="form-control" v-model="payment_details.payment_amount" />
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12">
                        <div class="form-group">
                            <label class="control-label">Cheque Details / Reference</label>
                            <input type="text" class="form-control" v-model="payment_details.payment_reference" />
                        </div>
                    </div>

                </div>
                <div class="panel-footer" v-show="selected_payment_method=='cheque'">
                    <div class="col-xs-12 text-right">
                        <button class="btn btn-primary" v-on:click="makeOfflinePayment()">Record Payment Details</button>
                    </div>
                    <div class="clearfix"></div>

                </div>

            </div>
        </div>
    </div>

    <div class="row" v-if="displayCard">
        <div class="col-sm-12 col-xs-12">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3 class="panel-title"><input type="radio" v-model="selected_payment_method" value="card" />&nbsp;Card Payment</h3>
                </div>
                <div class="panel-body" id="credit_card_options" v-show="selected_payment_method=='card'">
                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <div class="panel panel-default">
                                <div class="panel-body">
                                    <h3>Payment Details{{ invoice !== null ? ' - Invoice ' + invoice.invoice_number : ''}}</h3>
                                    <ul class="list-group" v-show="displayTransactionFees">
                                        <li class="list-group-item">Amount Due<span class="pull-right">{{ invoice !== null ? invoice.formatted_balance_due : ''}}</span> </li>
                                        <li class="list-group-item" v-show="displayTransactionFees && invoice !== null && cardCountry">Processing Fees<span class="pull-right">{{ invoice !== null && cardCountry ? formatCurrency(transactionFees(cardCountry)) : 'Dependent Upon Card'}}</span></li>

                                      <li class="list-group-item" v-show="displayTransactionFees && invoice !== null && !cardCountry">Processing Fees (UK Cards)<span class="pull-right">{{ invoice !== null && !cardCountry ? formatCurrency(transactionFees('GB')) : ''}}</span></li>
                                      <li class="list-group-item" v-show="displayTransactionFees && invoice !== null && !cardCountry">Processing Fees (EU Cards)<span class="pull-right">{{ invoice !== null && !cardCountry ? formatCurrency(transactionFees('DE')) : ''}}</span></li>
                                      <li class="list-group-item" v-show="displayTransactionFees && invoice !== null && !cardCountry">Processing Fees (Other Cards)<span class="pull-right">{{ invoice !== null && !cardCountry ? formatCurrency(transactionFees('US')) : ''}}</span></li>


                                      <li class="list-group-item" v-show="displayTransactionFees && cardCountry">
                                        <h4>Amount Due Including Fees<span class="pull-right">{{ invoice !== null ? formatCurrency(balanceDueInclTransactionFees(cardCountry)) : ''}}</span></h4>
                                      </li>
                                      <li class="list-group-item" v-show="displayTransactionFees && !cardCountry">
                                        <h4>Amount Due Including Fees<span class="pull-right">{{ invoice !== null ? invoice.formatted_balance_due : ''}} + Fees</span></h4>
                                      </li>
                                    </ul>
                                    <h4 v-show="!displayTransactionFees">Amount Due<span class="pull-right">{{ invoice !== null ? formatCurrency(balanceDueInclTransactionFees(cardCountry)) : ''}}</span></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <div class="panel panel-default">
                                <div class="panel-body">
                                    <h3>Payment Method</h3>
                                    <ul class="list-group">
                                        <li v-if="(payment_config != null) && (payment_config.payment_methods.card.allow_saving_cards == true)" class="list-group-item" v-for="card in payment_config.customer.stripe_payment_methods">
                                            <div class="radio">
                                                <label>
                                                    <input type="radio" :value="card" v-model="saved_card"/>
                                                    <credit-card :last4="card.last4" :brand="card.brand" :expiryMonth="card.exp_month" :expiryYear="card.exp_year"></credit-card>
                                                </label>
                                            </div>

                                        </li>
                                        <li class="list-group-item">
                                            <div class="radio"  v-if="payment_config.payment_methods.card.allow_saving_cards">
                                                <label>
                                                    <input type="radio" :value="null" v-model="saved_card"/>
                                                    Use a new card
                                                </label>
                                            </div>
                                            <div class="form-row" v-show="saved_card == null">
                                                <div class="form-group">
                                                    <label for="cardholder-name">Card Holder Name</label>
                                                    <input type="text" id="cardholder-name" class="form-control" v-model="cardholder_name"/>
                                                </div>
                                            </div>
                                            <div class="form-row" v-show="saved_card == null">
                                                <label for="card-element">
                                                    Credit or debit card
                                                </label>
                                                <div id="card-element">

                                                </div>

                                                <!-- Used to display form errors -->
                                                <div id="card-errors" role="alert"></div>


                                            </div>

                                            <!-- Confirm Payment Method Button -->
                                            <div v-show="requiresAction" class="form-row">
                                                <button
                                                    id="card-button"
                                                    class="btn"
                                                    :class="{ 'btn-default': paymentProcessing, 'btn-success': ! paymentProcessing }"
                                                    @click="confirmSCAPayment"
                                                    :disabled="paymentProcessing"
                                                >
                                                    <strong>{{ confirmationButtonLabel }}</strong>
                                                </button>
                                            </div>
                                            <div v-show="errorMessage" class="alert alert-danger">
                                                {{ errorMessage }}
                                            </div>
                                            <div v-show="successMessage" class="alert alert-success">
                                                {{ successMessage }}
                                            </div>

                                            <div class="checkbox"  v-show="saved_card == null" v-if="payment_config.payment_methods.card.allow_saving_cards">
                                                <label for="save-card">
                                                    <input type="checkbox" id="save-card" v-model="save_card"/>
                                                    Save Card Details
                                                </label>
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="panel-footer" v-show="selected_payment_method=='card'">
                    <div class="col-xs-12 text-right">
                        <button
                            class="btn"
                            :class="{ 'btn-default': paymentProcessing || requiresAction, 'btn-primary': ! (paymentProcessing || requiresAction ) }"
                            v-on:click="makeCardPayment()"
                            :disabled="paymentProcessing || requiresAction"
                        >
                            Make Payment
                        </button>
                    </div>
                    <div class="clearfix"></div>

                </div>
            </div>
        </div>
    </div>
    <vuedal></vuedal>
</div>


</template>
<style scoped>



</style>
<script>
import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
import { loadStripe } from '@stripe/stripe-js';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);
import { default as Vuedals, Component as Vuedal, Bus as VuedalsBus } from 'vuedals';
import Vue from "vue";
Vue.use(Vuedals);
export default {
    components: {DatePicker, Message, Tooltip, Icon, Loading, Vuedal},
    props: {
        invoice_id: {
            type: String,
            required: true
        }
    },

    data: function () {
        return {
            selected_payment_method: "card",
            payment_details: {
                payment_amount: 0,
                payment_date: moment().format('YYYY-MM-DD'),
                payment_reference: null,
            },
            invoice: null,
            stripe: null,
            payment_config: null,
            elements: null,
            payment_method: null,
            card: null,
            stripe_pk: '',
            stripe_account: '',
            cardholder_name: '',
            save_card: false,
            errors: [],
            success: false,
            payment: null,
            loading: true,
            requiresAction: false,
            paymentProcessing: false,
            paymentProcessed: false,
            successMessage: null,
            errorMessage: null,
            redirect: null,

            saved_card: null
        };
    },
    computed: {
        displayCard: function() {
            return this.payment_config !== null && this.invoice !== null && this.invoice.payment_options.card_allowed
        },
        displayBankTransfer: function() {
            return this.payment_config !== null && this.invoice !== null && this.invoice.payment_options.bank_transfer_allowed;
        },
        displayCashCheque: function() {
            return this.payment_config !== null && this.invoice !== null && this.invoice.payment_options.cheque_allowed;
        },
        displayTransactionFees: function() {
            return this.payment_config != null && this.invoice !== null && !this.payment_config.payment_methods.card.absorb_transaction_fees
        },
		absorbTransactionFees: function() {
			return this.payment_config != null && this.payment_config.payment_methods.card.absorb_transaction_fees
		},
        confirmationButtonLabel: function() {
            if (this.payment) {
                return `Confirm your ${this.payment.amount_formatted} payment`
            }
            return 'Confirm your payment'
        },
        cardCountry: function() {
            let country;
            if (this.saved_card) {
              country = this.saved_card.country;
            }
            else if (this.payment_method) {
              country = this.payment_method.card.country;
            }
            else {
              return null;
            }
            return country;
        }
    },
    async created() {
        console.log('Invoice payment component created.');
        await this.init();
        this.loading = false;

    },
    methods: {
        async init() {

            console.log('await getInvoiceData to be called');
            this.invoice = await this.getInvoiceData(this.invoice_id);
            this.payment_details.payment_amount = this.invoice.balance_due;
            this.payment_details.payment_reference = 'Invoice ' + this.invoice.invoice_number;
            console.log(this.invoice);
            console.log('await getInvoiceData finished');

            console.log('await getPaymentOptions to be called');
            this.payment_config = await this.getPaymentOptions(this.invoice_id);
            console.log(this.payment_config);
            console.log('await getPaymentOptions finished');
            this.selected_payment_method = this.payment_config.default_payment_method;

            if (this.payment_config.payment_methods.card) {
                this.cardholder_name = this.payment_config.customer.customer_name;
                this.cardholder_email = this.payment_config.customer.customer_email;

                console.log('await loadStripe to be called');
                console.log('stripe_pk: ' + this.payment_config.payment_methods.card.stripe_pk);
                console.log('stripe_account: ' + this.payment_config.payment_methods.card.stripe_account);
                await this.loadStripeJS(this.payment_config.payment_methods.card.stripe_pk, this.payment_config.payment_methods.card.stripe_account);
                console.log('await loadStripe finished');

                console.log('setupStripe to be called')
                await this.setupStripe();
                console.log('setupStripe finished')
            }
        },
        async getInvoiceData(invoice_id) {

            console.log('getInvoiceData');

            const invoice = axios.get(`/account/api/invoice/${invoice_id}`).then((response) => {
                console.log(response.data);
                return response.data;
            }).catch((error) => {
                this.$message({message: 'There was a problem loading the invoice details.', type: 'error'});
            });

            console.log('getInvoiceData end')

            return invoice;

        },
        async getPaymentOptions(invoice_id) {

            console.log('getPaymentOptions start');

            const payment_config = axios.get(`/account/api/payment_config`).then((response) => {
                console.log(response.data);
                return response.data;
            }).catch((error) => {
                this.$message({message: 'There was a problem loading the payment options.', type: 'error'});
            });

            console.log('getPaymentOptions end')

            return payment_config;
        },
        async loadStripeJS( stripe_pk, stripe_account, URL, callback ) {
            console.log('loadStripeJS');
            console.log('loadStripeJS stripe_pk: ' + stripe_pk);
            console.log('loadStripeJS stripe_account: ' + stripe_account);
            this.stripe = await loadStripe(stripe_pk, {
                stripeAccount: stripe_account
            });
            console.log(this.stripe.stripeAccount);


            console.log('loadStripeJS end');
            // return;
            // let documentTag = document, tag = 'script',
            //     object = documentTag.createElement(tag),
            //     scriptTag = documentTag.getElementsByTagName(tag)[0];
            // object.src = '//' + URL;
            // if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            // scriptTag.parentNode.insertBefore(object, scriptTag);
        },
        async setupStripe() {
            console.log('inside setupStripe');
            //const elements = stripe.elements();
                // this.stripe = Stripe('pk_test_keHzyGKxO88yxaNM18NOa1Oa', {
                //     // stripeAccount: this.this.payment_config.card.stripe_account,
                // });

                this.elements = this.stripe.elements();
                var style = {
                    base: {
                        color: "#32325d",
                    }
                };

                this.card = this.elements.create("card", { style: style });
                this.card.mount("#card-element");

        },
        /**
         * If the user ticked the "save card" box, we get a SetupIntent from the server and save the card to their account, then make the charge
         */
        async saveCardDetails() {
            console.log('Save card details');
            // Get PaymentIntent
            this.stripe.confirmCardSetup({
                type: 'card',
                card: this.card,
                billing_details: {
                    name: this.cardholder_name,
                },
            })

            // Stripe examples used the code below... kept in case we ever want to refer to it

            const { setupIntent, error } = await stripe.confirmCardSetup(
                clientSecret, {
                    payment_method: {
                        card: this.card,
                        billing_details: { name: this.cardholder_name }
                    }
                }
            );

            if (error) {
                // Display "error.message" to the user...
                console.log(error);
            } else {
                // The card has been verified successfully...
                console.log(setupIntent);
            }

            // End Stripe sample

        },
        /**
         * If the user did not tick the "save card" box, we just create the payment method for a one-time charge
         */
        async makeCardPayment() {
            console.log('Make card payment');
			// this.$message({message: 'We encountered a problem making the card payment - please try later.', type: 'error'});
			// return;

			this.paymentProcessing = true;
            // Get PaymentIntent
            console.log(this.stripe.stripeAccount);
            let payment_method_id, payment_method;
            if ( this.saved_card == null) {
                console.log('new card - creating payment method');
                payment_method = await this.createPaymentMethod();
                this.payment_method = payment_method;
                payment_method_id = payment_method ? payment_method.id : null;
            }
            else {
                console.log('using saved card id '  + this.saved_card.id);
                payment_method_id = this.saved_card.id;
                payment_method = this.saved_card;

            }
            // console.log('Payment method done... ');
            console.log(payment_method);
            // console.log(payment_method_id);

          
			if (payment_method_id) {
				
            axios.post(`/account/api/invoice/${this.invoice_id}/card_payment`,
                {
                    paymentMethodId: payment_method_id,
                    saveCard: this.save_card,
                    paymentMethod: payment_method
                })
            .then(response => {
                console.log('SWM pay invoice succeeded');
                if (response.data.status === 'PaymentSucceeded' && response.data.redirect) {
                    window.location = response.data.redirect;
                }
            }).catch(error => {
                console.log('SWM pay invoice error');
                if (error.response) {
                    if (error.response.data.status === 'PaymentActionRequired') {
                        this.payment = error.response.data.data.cashier_payment;
                        this.redirect = error.response.data.redirect;
                        this.$message({ message: 'Your payment requires additional confirmation', type: 'success'});
                        this.requiresAction = true;
						this.confirmSCAPayment();
                    }
                    else {
						// this.card.clear();
                        this.$message({message: error.response.data.message, type: 'error'});
                    }
                }
                else {
                    this.$message({message: 'There was a problem paying the invoice.', type: 'error'});
                }
            })
            .finally(() => {
                this.paymentProcessing = false;
            })
			}
			else {
				this.paymentProcessing = false;
			}

		},
        async createPaymentMethod() {
            console.log('createPaymentMethod');
            return await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.card,
                billing_details: {
                    name: this.cardholder_name,
                },
            })
            .then(response => {
                console.log('createPaymentMethod response');
                console.log(response);
				if (response.error) {
					console.log('error is here');
					this.$message({type: 'error', message: response.error.message});
				}
                return response.paymentMethod;
            })
            .catch(function(error) {
				this.$message({type: 'error', message: `There was a problem processing your payment. ${error.message}`});
                console.log('ERROR creating payment method');
				return null;
            });
        },
        async confirmSCAPayment() {

            this.paymentProcessing = false;
            this.paymentProcessed = false;
            this.successMessage = '';
            this.errorMessage = '';

            this.stripe.confirmCardPayment(
                this.payment.client_secret, {
                    payment_method: this.payment.payment_method
                }
            ).then( result => {
                this.paymentProcessing = false;
                console.log(result);
                if (result.error) {
                    console.error("SCA Error", result.error);
                    // error.code might be: payment_intent_authentication_failure or card_declined or something else, but in any case, we need a new payment method
                    this.paymentProcessed = false;
                    this.paymentProcessing = false;
                    this.requiresAction = false;
					this.card.clear();
                    this.$message({type: 'error', message: `There was a problem processing your payment. ${result.error.message}`});
                    this.displayErrorMessage('Please use another payment method');
                } else {
                    this.paymentProcessed = true;
                    this.requiresAction = false;

                    console.log(`Redirecting to ${this.redirect}`);
                    this.$message({type: 'success', message: 'The card payment was successful.'});
                    axios.post(`/account/api/invoice/${this.invoice_id}/confirm_card_payment`,
                        {
                            paymentIntentId: result.paymentIntent.id,
                        })
                    .then(response => {
                        console.log('SWM confirm invoice succeeded');
                        console.log(response.data);
                        if (response.data.status === 'PaymentSucceeded' && response.data.redirect) {
                            console.log(`Redirecting to ${response.data.redirect}`);
                            window.location = response.data.redirect;
                        }
                    }).catch(error => {
                        console.log('SWM pay invoice error');
                        if (error.response) {
                            console.log(error.response);
                            this.$message({message: error.response.data.message, type: 'error'});
							this.card.clear();
                        }
                        else {
                            this.$message({message: 'There was a problem paying the invoice in Swim Manager.', type: 'error'});
                        }
                    });
                }
            });
        },
        async makeOfflinePayment() {
            console.log('Make offline payment');


            axios.post(`/account/api/invoice/${this.invoice_id}/pay`,
                {
                    payment_method: this.selected_payment_method,
                    payment_amount: this.payment_details.payment_amount,
                    payment_date: this.payment_details.payment_date,
                    payment_reference: this.payment_details.payment_reference
                })
                .then(response => {
                    console.log('SWM make offline payment invoice response');
                    console.log(response.data);
					if (response.data.redirect) {
						if (this.selected_payment_method == 'bank_transfer') {
							this.displayBankTransferReminder(response.data.redirect);
						}
						else {
							window.location = response.data.redirect;
						}
					}
					else if (response.data.errors) {
						this.errors = response.data.errors;
					}
                }).catch(error => {
                console.log('SWM makeOfflinePayment invoice error');
                console.log(error);
                this.$message({message: 'There was a problem paying invoice.', type: 'error'});
            });

        },
        transactionFees(country) {
          if (this.invoice && this.payment_config) {
            let fees = this.stripeFees(country);
            return (
				( this.invoice.balance_due
					+ (this.payment_config.payment_methods.card.stripe_application_fee / 100)
					+ ( fees.fixed_fee / 100 )
				)
                / (1 - (fees.percentage / 100))
				)
				
                - this.invoice.balance_due;
          }
          else {
            return 0;
          }
        },
        balanceDueInclTransactionFees(country) {
			if(this.absorbTransactionFees) {
				return this.invoice.balance_due; 
			}
            return this.invoice.balance_due + this.transactionFees(country);
        },
  
        stripeFees(country) {
    
              /*  
                EU Countries
                Austria, Belgium, Bulgaria, Croatia, Republic of Cyprus, Czech Republic, Denmark, Estonia, 
                Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, 
                Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain and Sweden
      
                EEA Countries
                EEA includes EU countries and also Iceland, Liechtenstein and Norway
               */
              let eea_countries = [
                'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU',
                'MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO'
              ];
              if (country === 'GB') {
                return {
                  percentage: this.payment_config.payment_methods.card.stripe_percentage_fee_gb, 
                  fixed_fee: this.payment_config.payment_methods.card.stripe_fixed_fee_gb
                };
              }
              if (eea_countries.includes(country)) {
                return {
                  percentage: this.payment_config.payment_methods.card.stripe_percentage_fee_eu, 
                  fixed_fee: this.payment_config.payment_methods.card.stripe_fixed_fee_eu
                };
              }
      
              return {
                percentage: this.payment_config.payment_methods.card.stripe_percentage_fee_intl, 
                fixed_fee: this.payment_config.payment_methods.card.stripe_fixed_fee_intl
              };
          },
          displayErrorMessage(message) {
              this.errorMessage = message;
              setTimeout(() => {
                  this.errorMessage = null;
              }, 5000);
          },
          formatCurrency(amount) {
            const componentLocale = this.payment_config ? this.payment_config.intl_locale : 'en-GB'
            let ourLocale = Intl.NumberFormat(componentLocale, {
              style: 'currency',
              currency: this.invoice.currency_iso_code
            });
            return ourLocale.format(amount)
          },
          displayBankTransferReminder(redirect) {
              console.log('displayBankTransferReminder');
              this.$vuedals.$emit('new', {
                  name: 'bank-details',
                  title: 'Bank Details',
                  props: {
					  account_name: this.payment_config.payment_methods.bank_transfer.account_name,
					  account_number: this.payment_config.payment_methods.bank_transfer.account_number,
					  account_sort_code: this.payment_config.payment_methods.bank_transfer.sort_code,
					  payment_amount: this.payment_details.payment_amount,
					  payment_reference: this.payment_details.payment_reference,
                  },
				  onDismiss() {
					  console.log('onClose');
					  console.log(redirect);
					  window.location = redirect;
				  }, 
				  component: {
					  name: 'show-bank-details',
					  props: ['account_name', 'account_number','account_sort_code','payment_amount','payment_reference'],
					  template: `<div>
									  <p>Please remember that you also need to use your online banking to make the transfer with the following details (if you have not already done so):</p>
									  <dl class="dl-horizontal">
										  <dt>Account Name</dt>
										  <dd>{{ account_name }}</dd>
										  <dt>Sort Code</dt>
										  <dd>{{ account_sort_code }}</dd>
										  <dt>Account Number</dt>
										  <dd>{{ account_number }}</dd>
										  <dt>Payment Amount</dt>
										  <dd id="confirm_amount">{{ payment_amount }}</dd>
										  <dt>Reference</dt>
										  <dd id="confirm_reference">{{ payment_reference }}</dd>
									  </dl>
								  </div>`

						      
				  }
              });
          },
    }
}
</script>